var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPhoneNumber(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 51,
    viewBox: "0 0 49 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.466797,
    y: 0.5,
    width: 48.3333,
    height: 50,
    rx: 24.1667,
    fill: "#E8F2EE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.1338 30.6567V34.782C35.1339 35.0774 35.022 35.3618 34.8206 35.5779C34.6193 35.794 34.3434 35.9257 34.0488 35.9463C33.539 35.9813 33.1225 36 32.8005 36C22.4906 36 14.1338 27.6432 14.1338 17.3333C14.1338 17.0113 14.1513 16.5948 14.1875 16.085C14.2081 15.7904 14.3398 15.5145 14.5559 15.3131C14.772 15.1118 15.0564 14.9999 15.3518 15H19.4771C19.6218 14.9999 19.7614 15.0535 19.8688 15.1505C19.9762 15.2475 20.0437 15.381 20.0581 15.525C20.085 15.7933 20.1095 16.0068 20.1328 16.169C20.3646 17.7871 20.8398 19.3608 21.5421 20.8368C21.653 21.0702 21.5806 21.349 21.3706 21.4983L18.853 23.2973C20.3923 26.8842 23.2508 29.7426 26.8376 31.282L28.6343 28.769C28.7077 28.6663 28.8149 28.5927 28.937 28.5609C29.0592 28.5292 29.1886 28.5413 29.3028 28.5952C30.7786 29.2962 32.352 29.7701 33.9695 30.001C34.1316 30.0243 34.3451 30.05 34.6111 30.0757C34.7549 30.0904 34.8881 30.158 34.9849 30.2653C35.0816 30.3727 35.1351 30.5121 35.135 30.6567H35.1338Z",
    fill: "#5BB5A2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPhoneNumber);
export default __webpack_public_path__ + "static/media/ic-phone-number.6752e6ff1ba9eff586976c54a2a3a018.svg";
export { ForwardRef as ReactComponent };